import VueRouter from 'vue-router'

import loginViewVue from '../views/login-view.vue'
import mainViewVue from '../views/main-view.vue'

import demoAccessViewVue from '../views/main-view/demo-access-view.vue'
import qrCodeAccessViewVue from '../views/main-view/qr-code-access-view.vue'
import qrCodeAccessInfoViewVue from '../views/main-view/qr-code-access-info-view.vue'

import userActivitiesViewVue from '../views/main-view/user-activities-view.vue'
import licensesViewVue from '../views/main-view/licenses-view.vue'


export default new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', redirect:'login' },
        { path: '/login', name: 'login', component: loginViewVue},
        {
            path: '/main', name: 'main', component: mainViewVue, redirect: { name: 'licenses' }, children: [
            { path: 'licenses', name: 'licenses', component: licensesViewVue },
            { path: 'demo-access', name:'demo-access', component: demoAccessViewVue},
            { path: 'qr-code-access', name: 'qr-code-access', component: qrCodeAccessViewVue, children: [
                { path: 'qr-code-access-info', name: 'qr-code-access-info', component: qrCodeAccessInfoViewVue}
            ] },
            { path: 'user-activities', name: 'user-activities', component: userActivitiesViewVue },

        ]},

    ]
})